import { render, staticRenderFns } from "./moreArticles.vue?vue&type=template&id=1035ba7c&scoped=true&"
import script from "./moreArticles.vue?vue&type=script&lang=js&"
export * from "./moreArticles.vue?vue&type=script&lang=js&"
import style0 from "./moreArticles.vue?vue&type=style&index=0&id=1035ba7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035ba7c",
  null
  
)

export default component.exports